import CreateManagerForm from './CreateManagerForm';

export default CreateManagerForm;



// WEBPACK FOOTER //
// ./src/scenes/Managers/components/CreateManagerForm/index.ts